import { ContextHomeProp } from "building-types/site/ContextHomeProp";
import type { Site } from "building-types/site/site";
import { BuiltInSiteType } from "building-types/site/site";

export const defaultSiteValues: Site = {
  entityType: "SITE",
  name: "Site",
  sortIndex: 0,
  id: "",
  type: BuiltInSiteType.DYNAMIC,
  sideSetback: 86,
  backSetback: 40 * 12,
  frontSetback: 180,
  roadWidth: 480,
  sidewalk: true,
  curb: true,
  homeBackVerticalOffset: 0,
  homeFrontVerticalOffset: 0,
  backRoad: false,
  roadVerticalOffset: 0,
  sidewalkWidth: 48,
  curbHeight: 4,
  grassCurbWidth: 36,
  drivewayMaterial: "foundation0",
  fence: false,
  driveway: true,
  fenceHeight: 72,
  fenceSetback: 96,
  sidewalkRampLength: 36,
  frontWalk: true,
  frontWalkConnectedToDriveway: true,
  frontWalkConnectedSetback: 72,
  frontWalkWidth: 36,
  contextHomes: ContextHomeProp.DEFAULT,
};
